const POST_METHOD = "POST";
const GET_METHOD = "GET";

export default (apiClient, endpoints, handlers) => {
    const apiRequest = (method, endpoint, headers = {}, content = {}) => {
        switch(method) {
            case POST_METHOD: return apiClient.post(endpoint, { data: content }, headers);
            case GET_METHOD: return apiClient.get(endpoint, {}, headers);
            default: return Promise.reject('invalid requestType');
        }
    };
    
    //combined obj of all api request handlers (indexed by action type) 
    const requestHandlers = handlers.reduce((groupedHandlers, handler) => {
        return {...groupedHandlers, ...handler(apiRequest, endpoints)};
    }, {});

    return (action, store) => {
        if (requestHandlers[action.type]) {
            return requestHandlers[action.type](action, store)
        }
    }
}


// WEBPACK FOOTER //
// ./modules/Common/apiRequestHandler/combinedRequestHandler.js